module.exports = __webpack_public_path__ + "img/mrtx.e8e0fd47.jpg";